<script >
import { computed, inject } from 'vue-demi';
import { BaseConfigKey } from '@futuweb/community-activity-modules/lib/vue2/provider-config/index.es.js';
import { SKIN_NUM, SKIN } from '../../constants/index';
import i18n from './i18n.js';
import StockLogo from '../StockLogo.vue';
import Ellipsis from '../Ellipsis/index.vue';
const __sfc_main = {};
__sfc_main.props = {
  language: String,
  info: {
    type: Object,
    default: () => ({})
  },
  baseInfo: {
    type: Object,
    default: () => ({})
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const baseConfig = inject(BaseConfigKey);
  const props = __props;
  const langMap = computed(() => {
    return i18n.messages[props.language];
  });
  const skinStr = computed(() => {
    const skinNum = baseConfig.value.skin;
    if (skinNum === SKIN_NUM[SKIN.BLACK]) {
      return SKIN.BLACK;
    }
    return SKIN.WHITE;
  });
  return {
    langMap,
    skinStr
  };
};
__sfc_main.components = Object.assign({
  Ellipsis,
  StockLogo
}, __sfc_main.components);
export default __sfc_main;
</script>
<template>
    <div
        :class="['qa-card', skinStr]"
        v-if="info.question || info.answer"
    >
        <div class="qa-info question" v-if="info.question">
            <div class="avatar">
                <img :src="info.author && info.author.icon || require('../../assets/images/avatar.png')" alt="">
            </div>
            <div class="qa-info-wrap">
                <div class="qa-info-username">{{ info.author && info.author.nick || langMap['投资者'] }}</div>
                <div class="qa-info-text">
                    <Ellipsis :content="info.question" :language="language" />
                </div>
            </div>
        </div>
        <div class="qa-info" v-if="info.answer">
            <div class="avatar">
                <StockLogo :logo="baseInfo.logo" :lazy="true" />
            </div>
            <div class="qa-info-wrap">
                <div class="qa-info-username">{{ baseInfo.entName }}</div>
                <div class="qa-info-text">
                    <Ellipsis :content="info.answer" :language="language" />
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="less" scoped>
.qa-card {
    padding: 0.48rem 0;
    .qa-info {
        position: relative;
        display: flex;
        align-items: flex-start;

        & + .qa-info {
            margin-top: 0.48rem;
        }

        .avatar {
            margin-right: 0.2rem;
            img {
                width: 0.6rem;
                height: 0.6rem;
                border-radius: 50%;
                border: solid 1px;
            }
        }

        .qa-info-wrap {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            max-width: 4.8rem;
            font-size: 0.24rem;

            .qa-info-username {
                line-height: 0.32rem;
                font-weight: 500;
            }

            .qa-info-text {
                margin-top: 0.08rem;
                display: flex;
                line-height: 0.44rem;
                padding: 0.16rem;
                overflow: hidden;
                border-radius: 0.08rem;
            }
        }
    }

    &.white {
        .qa-info {
            .avatar {
                img {
                    border-color:#e9e9e9;
                }
            }

            .qa-info-wrap {
                color: #000;
                .qa-info-text {
                    color: #262626;
                    background-color: #F6F7F9;
                }
            }

            &.question {
                .qa-info-wrap {
                    .qa-info-text {
                        background-color: rgba(224, 236, 255, 0.7);
                    }
                }
            }
        }
    }

    &.black {
        .qa-info {
            .avatar {
                img {
                    border-color:#3e3e3e;
                }
            }

            .qa-info-wrap {
                color: #E5E5E5;
                .qa-info-text {
                    color: #E5E5E5;
                    background-color: #2C2F33;
                }
            }

            &.question {
                .qa-info-wrap {
                    .qa-info-text {
                        background-color: rgba(109, 165, 255, 0.2);
                    }
                }
            }
        }
    }
}
</style>
